.spinner-wrapper{position:relative}
/*# sourceMappingURL=shared-tests-index.component-OSQ4FVU6.css.map */
